import React, { useState, useEffect } from 'react';
import styles from '../styles/News.module.css';
import { newsData } from '../data/newsData';
import { fetchData } from '../utils/apiClient';

function News() {
    const [newsItems, setNewsItems] = useState(newsData);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const data = await fetchData('/api/getNews.php');
                if (data.status === 'success' && data.data.length > 0) {
                    setNewsItems(data.data);
                }
            } catch (err) {
                console.warn("ニュースの取得に失敗しました。モックデータを使用します。");
            }
        };
        fetchNews();
    }, []);

    // 表示するニュースの数を制御
    const visibleNewsItems = showAll ? newsItems : newsItems.slice(0, 3);

    return (
        <div className={styles.newsContainer}>
            <h2 className={styles.title}>News</h2>
            <div className={styles.newsGrid}>
                {visibleNewsItems.map((item, index) => (
                    <div key={index} className={styles.newsCard}>
                        <img
                            src={item.image || '/images/VRchara_web_normal.png'}
                            alt={`ニュース画像: ${item.title}`}
                            className={styles.newsImage}
                        />
                        <div className={styles.newsContent}>
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                            <a
                                href={item.link}
                                className={styles.newsButton}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                詳細を読む
                            </a>
                        </div>
                    </div>
                ))}
            </div>
            {!showAll && newsItems.length > 3 && (
                <button
                    className={styles.showAllButton}
                    onClick={() => setShowAll(true)}
                >
                    すべてを表示
                </button>
            )}
        </div>
    );
}

export default News;
